<template>
  <!-- Hero Section -->
  <Hero />

  <main id="main" class="nuxt-main">
    <!-- Services Section -->
    <section id="services" class="section-services">
      <div class="section-container">
        <div class="section-header">
          <span class="section-badge">Layanan Kami</span>
          <h2 class="section-title">Solusi Lengkap untuk <span class="text-gradient">Kebutuhan Anda</span></h2>
          <p class="section-desc">Kami menyediakan berbagai layanan profesional yang siap membantu menyelesaikan permasalahan Anda dengan cepat dan terpercaya.</p>
        </div>

        <div class="services-grid">
          <div class="service-card" v-for="(service, index) in services" :key="index">
            <div class="service-icon" :style="{ background: service.bgColor }">
              <img :src="service.icon" :alt="service.title" width="28" />
            </div>
            <h3 class="service-name">{{ service.title }}</h3>
            <p class="service-desc">{{ service.description }}</p>
            <div class="service-arrow">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why Us Section -->
    <section id="why-us" class="section-whyus">
      <div class="section-container">
        <div class="whyus-layout">
          <div class="whyus-content">
            <span class="section-badge">Keunggulan</span>
            <h2 class="section-title">
              Kenapa Harus Memilih <span class="text-gradient">Yohom?</span>
            </h2>

            <div class="accordion-list">
              <div
                v-for="(item, index) in whyUsItems"
                :key="index"
                class="accordion-item"
                :class="{ 'accordion-item--active': activeAccordion === index }"
                @click="toggleAccordion(index)"
              >
                <div class="accordion-header">
                  <div class="accordion-number">{{ String(index + 1).padStart(2, '0') }}</div>
                  <h4 class="accordion-title">{{ item.title }}</h4>
                  <div class="accordion-chevron">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </div>
                </div>
                <div class="accordion-body" v-if="activeAccordion === index">
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="whyus-visual">
            <div class="visual-card">
              <img src="assets/img/why-us.png" alt="Kenapa Yohom" class="whyus-img" />
              <div class="visual-overlay">
                <div class="overlay-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  <span>Terpercaya</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
    <section id="partners" class="section-partners">
      <div class="section-container">
        <div class="section-header">
          <span class="section-badge">Mitra Kerja</span>
          <h2 class="section-title">Partner <span class="text-gradient">Kami</span></h2>
          <p class="section-desc">Kami dipercaya oleh berbagai institusi dan perusahaan terkemuka di Indonesia.</p>
        </div>

        <div class="partners-grid">
          <div v-for="partner in partners" :key="partner.img" class="partner-card">
            <img :src="partner.img" :alt="partner.img" class="partner-logo" />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Hero from "../components/templates/Hero.vue";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Hero,
  },
  data() {
    return {
      activeAccordion: 0,
      services: [
        {
          icon: "assets/icons/yo_rumah.png",
          title: "Yo Rumah",
          description: "Layanan Yohom yang memberikan solusi kerusakan rumah Anda seperti atap, plumbing dan lainnya.",
          bgColor: "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.08) 100%)",
        },
        {
          icon: "assets/icons/yo_elektro.png",
          title: "Yo Elektro",
          description: "Solusi perbaikan barang elektronik kesayangan Anda dengan teknisi berpengalaman.",
          bgColor: "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.08) 100%)",
        },
        {
          icon: "assets/icons/yo_urgent.png",
          title: "Yo Urgent",
          description: "Dalam kondisi darurat, kami siap memberikan layanan cepat untuk Anda kapan saja.",
          bgColor: "linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.08) 100%)",
        },
      ],
      whyUsItems: [
        {
          title: "Solusi Permasalahan Anda",
          description: "Hal pertama yang teringat jika ditanya tentang Yohom tentunya adalah Solusi. Yohom merupakan aplikasi yang akan membantu permasalahan keseharian Anda seperti kerusakan AC, Atap, Saluran Air dan lainnya.",
        },
        {
          title: "Mudah & Praktis Digunakan",
          description: "Aplikasi Yohom merupakan aplikasi yang berbasis pada Smartphone dimana pengguna sudah sangat familiar. Jadi, penggunaan Yohom sangat Mudah dan Praktis.",
        },
        {
          title: "Pelayanan yang Ramah dan Bergaransi",
          description: "Kami sangat menjamin bahwa pelayanan pada Yohom sangatlah baik. Selain itu Yohom juga memberikan Garansi pada permasalahan yang Anda hadapi.",
        },
      ],
      partners: [
        { img: "assets/img/partner/kemenaker.png" },
        { img: "assets/img/partner/sinarmas.png" },
        { img: "assets/img/partner/TOEKANG-HUB-LOGO-800px.png" },
        { img: "assets/img/partner/ARCHLAB-LOGO-800px.png" },
      ],
      config: {
        headers: { api_key: "yohom_12345" },
      },
      apiUrl: "https://admincp.yohom.co.id/api/",
    };
  },
  mounted() {
    // this.getMedsos();
  },
  methods: {
    toggleAccordion(index) {
      this.activeAccordion = this.activeAccordion === index ? null : index;
    },
    getMedsos() {
      axios
        .get(this.apiUrl + "medsos", this.config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;600;700;800&display=swap');

.nuxt-main {
  font-family: 'Public Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  background: #fcfcfd;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ============================
   Shared Section Styles
   ============================ */
.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 100px;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid rgba(16, 185, 129, 0.15);
  margin-bottom: 16px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  letter-spacing: -0.025em;
  margin: 0 0 12px;
}

.text-gradient {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-desc {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  max-width: 560px;
  margin: 0 auto;
}

/* ============================
   Services Section
   ============================ */
.section-services {
  padding: 80px 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.service-card {
  position: relative;
  padding: 32px 28px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: default;
  overflow: hidden;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #10b981, #059669);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.service-card:hover {
  border-color: rgba(16, 185, 129, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transform: translateY(-4px);
}

.service-card:hover::before {
  transform: scaleX(1);
}

.service-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  margin-bottom: 20px;
}

.service-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
  letter-spacing: -0.01em;
}

.service-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 16px;
}

.service-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
  transition: all 0.2s ease;
}

.service-card:hover .service-arrow {
  background: #10b981;
  color: #fff;
  transform: translateX(4px);
}

/* ============================
   Why Us Section
   ============================ */
.section-whyus {
  padding: 80px 0;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
  border-bottom: 1px solid #f3f4f6;
}

.whyus-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.whyus-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.whyus-content .section-title {
  text-align: left;
}

/* Accordion */
.accordion-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.accordion-item {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.accordion-item:hover {
  border-color: #d1d5db;
}

.accordion-item--active {
  border-color: rgba(16, 185, 129, 0.3);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);
}

.accordion-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
}

.accordion-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(16, 185, 129, 0.08);
  color: #059669;
  font-size: 13px;
  font-weight: 700;
}

.accordion-item--active .accordion-number {
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
}

.accordion-title {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.accordion-item--active .accordion-title {
  color: #111827;
}

.accordion-chevron {
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.accordion-item--active .accordion-chevron {
  transform: rotate(180deg);
  color: #059669;
}

.accordion-body {
  padding: 0 20px 16px 72px;
}

.accordion-body p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0;
}

/* Visual */
.whyus-visual {
  display: flex;
  justify-content: center;
}

.visual-card {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.whyus-img {
  display: block;
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.visual-overlay {
  position: absolute;
  bottom: 20px;
  left: 20px;
}

.overlay-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #059669;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* ============================
   Partners Section
   ============================ */
.section-partners {
  padding: 80px 0;
}

.partners-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 110px;
  padding: 20px 32px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.partner-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.partner-logo {
  max-width: 100%;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: grayscale(40%);
  opacity: 0.8;
  transition: all 0.3s ease;
}

.partner-card:hover .partner-logo {
  filter: grayscale(0);
  opacity: 1;
}

/* ============================
   Responsive
   ============================ */
@media (max-width: 968px) {
  .services-grid {
    grid-template-columns: 1fr;
    max-width: 480px;
    margin: 0 auto;
  }

  .whyus-layout {
    grid-template-columns: 1fr;
  }

  .whyus-visual {
    order: -1;
  }

  .whyus-content .section-title {
    text-align: center;
  }

  .whyus-content .section-badge {
    align-self: center;
  }
}

@media (max-width: 640px) {
  .section-services,
  .section-whyus,
  .section-partners {
    padding: 60px 0;
  }

  .section-title {
    font-size: 28px;
  }

  .accordion-body {
    padding-left: 20px;
  }
}
</style>